import React from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { TextField, IconButton } from '@material-ui/core';
import { Add, Delete } from '@material-ui/icons';

function AddCondiments({ formik }) {
  const addNewItem = () => {
    const newItem = { description: '', price: '', additionals: [] };
    formik.setFieldValue('condiments', [...formik.values.condiments, newItem]);
  };

  const removeItem = (index) => {
    const updatedItems = formik.values.condiments.filter((_, i) => i !== index);
    formik.setFieldValue('condiments', updatedItems);
  };

  const addNewAdditional = (itemIndex) => {
    const newAdditional = { item: '', quantity: '', price: '' };
    const updatedItems = [...formik.values.condiments];
    updatedItems[itemIndex].additionals.push(newAdditional);
    formik.setFieldValue('condiments', updatedItems);
  };

  const removeAdditional = (itemIndex, additionalIndex) => {
    const updatedItems = [...formik.values.condiments];
    updatedItems[itemIndex].additionals = updatedItems[
      itemIndex
    ].additionals.filter((_, i) => i !== additionalIndex);
    formik.setFieldValue('condiments', updatedItems);
  };

  return (
    <div>
      <Form>
        {formik.values.condiments.map((item, index) => (
          <div key={index} className="mb-4">
            <Row className="align-items-center">
              <Col md={5}>
                <div className="my-2 f14-500">
                  condiments and Food description
                </div>
                <TextField
                  label="Condiments & Food Description"
                  name={`condiments.${index}.description`}
                  value={item.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  variant="outlined"
                  error={
                    formik.errors.condiments?.[index]?.description &&
                    formik.touched.condiments?.[index]?.description
                  }
                  helperText={
                    formik.errors.condiments?.[index]?.description &&
                    formik.touched.condiments?.[index]?.description
                      ? formik.errors.condiments[index].description
                      : ''
                  }
                />
              </Col>
              <Col md={3}>
                <div className="my-2 f14-500">Price</div>
                <TextField
                  label="Price"
                  name={`condiments.${index}.price`}
                  value={item.price}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  variant="outlined"
                  error={
                    formik.errors.condiments?.[index]?.price &&
                    formik.touched.condiments?.[index]?.price
                  }
                  helperText={
                    formik.errors.condiments?.[index]?.price &&
                    formik.touched.condiments?.[index]?.price
                      ? formik.errors.condiments[index].price
                      : ''
                  }
                />
              </Col>
              <Col md={4}>
                <div className="my-2 f14-500">Additional</div>
                <div className="d-flex align-items-center">
                  <IconButton onClick={addNewItem}>
                    <Add />
                  </IconButton>
                  {formik.values?.condiments?.length > 1 && (
                    <IconButton onClick={() => removeItem(index)}>
                      <Delete />
                    </IconButton>
                  )}
                </div>
              </Col>
            </Row>
            {/* Manage additionals */}
            {item.additionals.map((additional, i) => (
              <Row key={i} className="align-items-center mt-2 ml-4">
                <Col md={2}>
                  <TextField
                    label="Item"
                    name={`condiments.${index}.additionals.${i}.item`}
                    value={additional.item}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    variant="outlined"
                    error={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.item &&
                      formik.touched.condiments?.[index]?.additionals?.[i]?.item
                    }
                    helperText={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.item &&
                      formik.touched.condiments?.[index]?.additionals?.[i]?.item
                        ? formik.errors.condiments[index].additionals[i].item
                        : ''
                    }
                  />
                </Col>
                <Col md={2}>
                  <TextField
                    label="Quantity"
                    name={`condiments.${index}.additionals.${i}.quantity`}
                    value={additional.quantity}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    variant="outlined"
                    error={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.quantity &&
                      formik.touched.condiments?.[index]?.additionals?.[i]
                        ?.quantity
                    }
                    helperText={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.quantity &&
                      formik.touched.condiments?.[index]?.additionals?.[i]
                        ?.quantity
                        ? formik.errors.condiments[index].additionals[i]
                            .quantity
                        : ''
                    }
                  />
                </Col>
                <Col md={2}>
                  <TextField
                    label="Price"
                    name={`condiments.${index}.additionals.${i}.price`}
                    value={additional.price}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    variant="outlined"
                    error={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.price &&
                      formik.touched.condiments?.[index]?.additionals?.[i]
                        ?.price
                    }
                    helperText={
                      formik.errors.condiments?.[index]?.additionals?.[i]
                        ?.price &&
                      formik.touched.condiments?.[index]?.additionals?.[i]
                        ?.price
                        ? formik.errors.condiments[index].additionals[i].price
                        : ''
                    }
                  />
                </Col>
                <Col md={3}>
                  <IconButton onClick={() => addNewAdditional(index)}>
                    <Add />
                  </IconButton>
                  {item.additionals.length > 1 && (
                    <IconButton onClick={() => removeAdditional(index, i)}>
                      <Delete />
                    </IconButton>
                  )}
                </Col>
              </Row>
            ))}
            <Button variant="link" onClick={() => addNewAdditional(index)}>
              Add +
            </Button>
          </div>
        ))}
      </Form>
    </div>
  );
}

export default AddCondiments;
